"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticatedRegistrationWarning = void 0;
var AuthenticatedRegistrationWarning_1 = require("./AuthenticatedRegistrationWarning");
Object.defineProperty(exports, "AuthenticatedRegistrationWarning", { enumerable: true, get: function () { return AuthenticatedRegistrationWarning_1.AuthenticatedRegistrationWarning; } });
